"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { Collapsible as collapsible_Collapsible } from "@base-ui/react/collapsible";
import { forwardRef, isValidElement, useState } from "react";
import { cn } from "../../utils/index.js";
import { Chevron } from "../SVG/Chevron/index.js";
import { collapsibleVariants } from "./Collapsible.variants.js";
const Collapsible_Collapsible = /*#__PURE__*/ forwardRef(function({ children, className, triggerClassName, panelId = 'collapsible-panel-id-default', withTriggerIcon = true, triggerIconPosition = 'right', flushAligned = false, elevated = false, plain = false, heading, collapsedFooter, expandedFooter, open, onOpenChange, defaultOpen = false }, ref) {
    const variants = collapsibleVariants({
        flushAligned,
        elevated,
        plain
    });
    const [uncontrolledOpen, setUncontrolledOpen] = useState(defaultOpen);
    const isOpen = 'boolean' == typeof open ? open : uncontrolledOpen;
    const handleOpenChange = (newOpen)=>{
        if ('boolean' != typeof open) setUncontrolledOpen(newOpen);
        onOpenChange?.(newOpen);
    };
    const rootClasses = cn(variants.root({
        isOpen
    }), className);
    const triggerClasses = cn(variants.trigger({
        isOpen
    }), triggerClassName);
    return /*#__PURE__*/ jsxs(collapsible_Collapsible.Root, {
        ref: ref,
        open: isOpen,
        onOpenChange: handleOpenChange,
        className: rootClasses,
        "data-testid": "base-collapsible-root",
        "data-state": isOpen ? 'open' : 'closed',
        children: [
            /*#__PURE__*/ isValidElement(heading) && /*#__PURE__*/ jsx(collapsible_Collapsible.Trigger, {
                render: (props)=>/*#__PURE__*/ jsxs("div", {
                        ...props,
                        role: "button",
                        tabIndex: 0,
                        onMouseDown: (e)=>e.preventDefault(),
                        "data-testid": "collapsible-trigger",
                        children: [
                            withTriggerIcon && 'left' === triggerIconPosition && /*#__PURE__*/ jsx(Chevron, {
                                isOpen: isOpen,
                                size: 24
                            }),
                            heading,
                            withTriggerIcon && 'right' === triggerIconPosition && /*#__PURE__*/ jsx(Chevron, {
                                isOpen: isOpen,
                                size: 24
                            })
                        ]
                    }),
                nativeButton: false,
                className: triggerClasses
            }),
            /*#__PURE__*/ jsx(collapsible_Collapsible.Panel, {
                className: variants.panel(),
                id: panelId,
                "data-testid": "collapsible-panel",
                keepMounted: true,
                children: children
            }),
            /*#__PURE__*/ isValidElement(collapsedFooter) && /*#__PURE__*/ isValidElement(expandedFooter) && /*#__PURE__*/ jsxs(collapsible_Collapsible.Trigger, {
                className: variants.footerTrigger(),
                onMouseDown: (e)=>e.preventDefault(),
                "data-testid": "collapsible-footer",
                children: [
                    withTriggerIcon && 'left' === triggerIconPosition && /*#__PURE__*/ jsx(Chevron, {
                        isOpen: isOpen,
                        size: 24
                    }),
                    /*#__PURE__*/ jsxs("div", {
                        className: "relative",
                        children: [
                            /*#__PURE__*/ jsx("div", {
                                "data-testid": "collapsible-footer-collapsed",
                                className: cn(variants.footer(), 'transition-opacity', isOpen ? 'pointer-events-none absolute inset-0 opacity-0' : 'relative opacity-100'),
                                children: collapsedFooter
                            }),
                            /*#__PURE__*/ jsx("div", {
                                "data-testid": "collapsible-footer-expanded",
                                className: cn(variants.footer(), 'transition-opacity', isOpen ? 'relative opacity-100' : 'pointer-events-none absolute inset-0 opacity-0'),
                                children: expandedFooter
                            })
                        ]
                    }),
                    withTriggerIcon && 'right' === triggerIconPosition && /*#__PURE__*/ jsx(Chevron, {
                        isOpen: isOpen,
                        size: 24
                    })
                ]
            })
        ]
    });
});
export { Collapsible_Collapsible as Collapsible };
